'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: '请选择时间'
};
exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/time-picker/locale/zh_CN.js
// module id = 1163
// module chunks = 0